import { IonButton, IonIcon, IonItem, IonList } from "@ionic/react";
import { createOutline } from "ionicons/icons";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { Spacer } from "../../../components/spacer";
import { getEntries } from "../../../services/users";
import { formatDate } from "../../../services/util";

interface props {
	user: any;
	dateTS: any;
}

const DateEatView: React.FC<props> = ({ dateTS, user }) => {
	const history = useHistory();
	const [entries, setEntries] = useState<any>([]);

	useEffect(() => {
		if (!user.id) user.id = user.uid;
		if (user && user.id && dateTS) {
			getEntries(user.id).then((docs: any) => {
				let validEntries = Object.values(docs).filter(
					(doc: any) => doc.dateTS === dateTS
				);
				setEntries(validEntries);
			});
		}
	}, [user]);

	const getDate = () => {
		return formatDate(parseInt(dateTS));
	};

	const mealDisplayString = (meal: any) => {
		switch (meal) {
			case "breakfast":
				return "Breakfast";
				break;
			case "morningTea":
				return "Morning Tea";
				break;
			case "lunch":
				return "Lunch";
				break;
			case "afternoonTea":
				return "Afternoon Tea";
				break;
			case "dinner":
				return "Dinner";
				break;
			case "snack":
				return "Snack";
				break;
			default:
				break;
		}
	};

	return (
		<>
			<IonList>
				{entries && (
					<>
						<h1>Entries for {getDate()} </h1>
						<Spacer size="30" />
						{entries.length === 0 && <p>You have not made any entries yet</p>}
						{entries.map((el: any, idx: any) => (
							<IonItem
								button
								key={idx}
								onClick={() => history.push(`/users/${user.id}/entry/${el.id}`)}
							>
								{mealDisplayString(el.meal)}
								<IonIcon slot="end" icon={createOutline} />
							</IonItem>
						))}
					</>
				)}
			</IonList>
			<Spacer size="30" />
			<IonButton
				onClick={() => history.push(`/users/${user.id}/entry/new/${dateTS}`)}
			>
				Add Entry
			</IonButton>
		</>
	);
};

const mapStateToProps = (state: any) => ({
	usersData: state.user.users,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DateEatView);
